module.exports = __webpack_public_path__ + "img/1.251ec262.png";